let scrollLeftBtn = document.getElementsByClassName('company-performance__control--previous');
let scrollRightBtn = document.getElementsByClassName('company-performance__control--next');
let performanceTable = document.getElementsByClassName('company-performance__table');

for (let i = 0; i < scrollRightBtn.length; i++) {

    scrollRightBtn[i].addEventListener('click', function() {
        // Check button attribute to select the right table (water only or sewerage).
        let table = document.getElementById('company-performance-' + this.getAttribute('data-type'));
        table.scrollLeft += 190; // Scroll table right 190px

        // Enable the scroll left button.
        this.previousElementSibling.removeAttribute('disabled');

        // Disable the scroll right button when we reach the end of the table.
        if (table.scrollLeft === (table.querySelectorAll('thead')[0].offsetWidth - table.offsetWidth + 4)) {
            this.setAttribute('disabled', true);
        }
    });

    scrollLeftBtn[i].addEventListener('click', function() {
        // Check button attribute to select the right table (water only or sewerage).
        let table = document.getElementById('company-performance-' + this.getAttribute('data-type'));
        table.scrollLeft -= 190; // Scroll table left 190px;

        // Enable the scroll right button.
        this.nextElementSibling.removeAttribute('disabled');

        // Start of table reached, disable left scrolling.
        if (table.scrollLeft === 0) {
            this.setAttribute('disabled', true);
        }
    });

}

// Remove/Add opacity overlay on table scroll.
for (let i = 0; i < performanceTable.length; i++) {
    performanceTable[i].addEventListener('scroll', (e) => {
        // Remove opacity overlay on scroll.
        e.target.parentElement.classList.remove('company-performance__overlay--visible');

        // Add scroll class to table.
        e.target.classList.add('company-performance__table--scroll');

        if (e.target.scrollLeft === 0) {
            // Add opacity overlay.
            e.target.parentElement.classList.add('company-performance__overlay--visible');

            // Remove scroll class to table.
            e.target.classList.remove('company-performance__table--scroll');
        }
    });

    // Scroll to start on window resize.
    window.addEventListener('resize', () => {
        performanceTable[i].scrollLeft = 0;
    });

    let tooltipTriggers = performanceTable[i].getElementsByClassName('tooltip__trigger');
    Array.from(tooltipTriggers).forEach((tooltipTrigger) => {
        tooltipTrigger.addEventListener('focusin', () => {
            // Get th cell containing the trigger.
            moveItemInViewport(tooltipTrigger.parentElement.parentElement, performanceTable[i]);
        });
    });
}

/**
 * Moves item in viewport if not completely visible.
 */
function moveItemInViewport(item, carousel) {
    let tableType = carousel.getAttribute('id').split('company-performance-').pop();
    let sliderContainerRect = carousel.getBoundingClientRect();
    let controls = document.querySelectorAll('button[data-type="' + tableType + '"]');

    if (
        item.offsetLeft + item.offsetWidth >
        sliderContainerRect.left + carousel.scrollLeft + 190
    ) {
        carousel.scrollLeft += 190;

    }
    if (item.offsetLeft <= carousel.scrollLeft) {
        carousel.scrollLeft -= 190;
    }

    // Scroll started, enable left scrolling.
    if (carousel.scrollLeft > 190) {
        controls.forEach(control => {
            if (control.classList.contains('company-performance__control--previous')){
                control.removeAttribute('disabled');
            }
        });
    }
    else {
        // Start of table reached, disable left scrolling.
        controls.forEach(control => {
            if (control.classList.contains('company-performance__control--previous')){
                control.setAttribute('disabled', true);
            }
        });
    }
}